
import React from "react";
import Modal from "../../../styled-base/modal";
import ModalHeader from "../../../components/modals/commons/modalHeader";
import ModalFooter from "../../../components/modals/commons/modalFooter";
import "./orgResultsDialogs.scss";
import { imgUrl } from '../../../utils/url';
// import topImg from "../MessageSamples/samples/top.PNG";
// import bottomImg from "../MessageSamples/samples/bottom.PNG";
// import zeroImg from "../MessageSamples/samples/zero.PNG";

const SampleMessageDialog = (props: any) => {
    return (
      <Modal 
          //isFixed={true}
          width={400}
          //style={{width: "550px !important", transform: "translate(14%, calc(50% - 275px)) !important"}}
          // minHeight="250px"
          // maxHeight="550px"
          // height="auto"
          id="sampleMessageDialog"
          //position={{ x: '14% !important', y: 'calc(50% - 275px) !important' }}
          // style={{left: "calc(50% - 140px) !important"}}
          
          transform_property={true}
          transform_property_lm={false}>
          <div className={`wbmodal `} style={{width: "400px !important"}}>
              <ModalHeader 
                  title = "Message Preview"
                  closePopup = {props.closePopup}
              />
              <div className="wbmodal-content" >
                  <div className={`preview ${props.type}`} >
                      <img src={imgUrl(`/images/org_results/Email-${props.type}.png`)} className="email-screenshot" />
                  </div>
              </div>
              <ModalFooter
                  addItem=  {props.closePopup}
                  buttonLabel = "Done"
                  closePopup = {null}
                  itemsLength= {1}
              />
          </div>
      </Modal>    
    );
}

export default SampleMessageDialog;
